import React from 'react';
import PropTypes from 'prop-types';

import { activePersonForImportedFile } from './activePersonForImportedFile';

const setActivePersonForImportedFile = (setActivePersonForImportedFileCabinDistributor, setActiveCabinForImportedFileCabinDistributor, data) => {
  const objectToSend = activePersonForImportedFile(data);
  setActivePersonForImportedFileCabinDistributor(objectToSend);
  setTimeout(() => {
    const firstChildInCabinOutHomeLi = document.querySelector('.cabin-distributor-cabins > li');
    const firstChildInCabinOutHomeId = firstChildInCabinOutHomeLi && firstChildInCabinOutHomeLi.getAttribute('id');
    if (firstChildInCabinOutHomeId && firstChildInCabinOutHomeId.length) {
      setActiveCabinForImportedFileCabinDistributor(firstChildInCabinOutHomeId);
    }
    if (!firstChildInCabinOutHomeLi) {
      setActiveCabinForImportedFileCabinDistributor('');
    }
  }, 0);
};

const PersonCluster = ({
  data,
  activePersonInCabinDistributor,
  setActiveCabinForImportedFileCabinDistributor,
  setActivePersonForImportedFileCabinDistributor,
  index,
  toManyPassengersForCabin,
}) => (
  <li
    key={data.id}
    className={[
      activePersonInCabinDistributor === data.id ? 'selected-person-li' : '',
      data.active && activePersonInCabinDistributor !== data.id ? 'active-person-li' : '',
      toManyPassengersForCabin ? 'deactivate-person-li' : '',
    ].join('')}
  >
    <div className="cabin-distributor-persons-names-container">
      <div className="cabin-distributor-persons-number"># {index + 1}</div>
      <div className="cabin-distributor-person-click" role="button" tabIndex={0} onClick={() => setActivePersonForImportedFile(setActivePersonForImportedFileCabinDistributor, setActiveCabinForImportedFileCabinDistributor, data)} />
      {data.map(d => (
        <div
          key={d.id}
          className={[
            'cabin-distributor-persons-names',
          ].join('')}
        >
          {d.map((item) => {
            const itemName = item && Object.keys(item)[0].toString();
            const itemValue = item && Object.values(item)[0];
            const itemId = item && Object.values(item)[1];
            if (itemName === 'firstName' || itemName === 'lastName') {
              return <div key={itemId}>{itemValue}</div>;
            }
            return null;
          })}
        </div>
        ))}
    </div>
    <div className="cabin-distributor-persons-ages">
      {data.ages ? Object.entries(data.ages).sort().map(a => <div key={`${a.id}${a[0]}`}><span className="name">{a[0] !== 'id' ? `${a[0]}:` : null}</span><span className="number">{a[0] !== 'id' ? a[1] : null}</span></div>) : null}
    </div>
  </li>
);

PersonCluster.propTypes = {
  data: PropTypes.array,
  setActiveCabinForImportedFileCabinDistributor: PropTypes.func,
  setActivePersonForImportedFileCabinDistributor: PropTypes.func,
  activePersonInCabinDistributor: PropTypes.string,
  index: PropTypes.number,
  toManyPassengersForCabin: PropTypes.bool,
};

export default PersonCluster;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/cabin/personCluster.js